/* tslint:disable */
/* eslint-disable */
/**
 * partnerDriverWeb driver-auth api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { VerificationCodeChannelClientOption } from './VerificationCodeChannelClientOption';

export interface ResendVerificationCodeResponse {
    verification_token: string;
    verification_code_channel: VerificationCodeChannelClientOption;
    verification_code_target: string;
    verification_code_length: number;
    resend_wait_time_seconds: number;
    available_verification_code_channels: Array<VerificationCodeChannelClientOption>;
}
